import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { X } from 'lucide-react';

const AdBanner = () => {
  const { API, user } = useAuth();
  const [ad, setAd] = useState(null);
  const [piano, setPiano] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) return;
    const checkPlan = async () => {
      try {
        const res = await axios.get(`${API}/me/piano`);
        setPiano(res.data.piano);
      } catch { setPiano('free'); }
    };
    checkPlan();
  }, [API, user]);

  useEffect(() => {
    if (piano !== 'free') return;
    const fetchAd = async () => {
      try {
        const res = await axios.get(`${API}/ads/random`);
        if (res.data.ad) setAd(res.data.ad);
      } catch {}
    };
    fetchAd();
    const interval = setInterval(fetchAd, 45000);
    return () => clearInterval(interval);
  }, [API, piano]);

  if (piano !== 'free' || !ad || dismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 flex justify-center pointer-events-none" data-testid="ad-banner">
      <div className="pointer-events-auto mx-4 mb-3 relative group">
        <a href={ad.clickUrl} target="_blank" rel="noopener noreferrer sponsored"
          className="block rounded-lg overflow-hidden shadow-sm border border-gray-200/50 opacity-60 hover:opacity-90 transition-opacity">
          <img src={ad.imageUrl} alt={ad.programName} className="h-[45px] w-auto object-contain bg-white"
            loading="lazy" onError={() => setAd(null)} />
          <img src={ad.impUrl} alt="" className="hidden" width="1" height="1" />
        </a>
        <button onClick={() => setDismissed(true)}
          className="absolute -top-2 -right-2 w-5 h-5 bg-white border border-gray-200 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-sm"
          aria-label="Chiudi">
          <X className="w-3 h-3 text-gray-400" />
        </button>
        <span className="absolute -top-1 left-1 text-[8px] text-gray-300 opacity-0 group-hover:opacity-100 transition-opacity">annuncio</span>
      </div>
    </div>
  );
};

export default AdBanner;
